import React from 'react';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
const galleryImages = ['https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1574096079513-d8259312b785?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1560624052-449f5ddf0c31?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1525268771113-32d9e9021a97?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1572116469696-31de0f17cc34?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&q=80&w=800'];
export function GalleryPage() {
  return <main className="bg-obsidian min-h-screen" data-id="element-223">
      <div className="pt-24 md:pt-28 pb-16 px-6 md:px-8 max-w-7xl mx-auto" data-id="element-224">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12 md:mb-16" data-id="element-225">
          <h1 className="text-5xl md:text-8xl font-serif text-champagne mb-6 italic" data-id="element-226">
            GALLERY
          </h1>
          <p className="text-white/60 font-sans text-xl md:text-2xl max-w-2xl mx-auto" data-id="element-227">
            Capturing the pulse of DC's most legendary institution.
          </p>
        </motion.div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 md:gap-8 space-y-6 md:space-y-8" data-id="element-228">
          {galleryImages.map((img, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative group overflow-hidden border border-white/5" data-id="element-229">
              <img src={img} alt={`District 14 ${idx}`} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-230" />
              <div className="absolute inset-0 border-0 group-hover:border-[1px] border-champagne transition-all duration-500 z-10" data-id="element-231" />
            </motion.div>)}
        </div>
      </div>
      <Footer data-id="element-232" />
    </main>;
}